module.exports = __webpack_public_path__ + "static/media/Take the tour  So you are looking for some help.b1d9d7f7.mp4";